// Module
var code = "<p>This is a binary prediction market.</p> <p>The collateral ratio of this market is 1:1.</p> ";
// Exports
export default code;